import portfolio_items_data from './data/portfolio_items.json'
import portfolio_categories_data from './data/portfolio_categories.json'

export function get_portfolio_items() {
    const data = portfolio_items_data.items 
    const status = 200
    return { status, data }
}

export function get_portfolio_item_by_id(pid) {
    const data = portfolio_items_data.items.find( (p)=> p.id == pid )
    const status = 200
    return { status, data }
}

export function get_portfolio_categories() {
    const data = portfolio_categories_data.categories
    const status = 200
    return { status, data } 
}

export function get_portfolio_category_by_id(category_id) {
    const data = portfolio_categories_data.categories.find( (c) => c.id == category_id )
    const status = 200
    // console.log(JSON.stringify(data))
    return { status, data }
}

export async function get_portfolio_category_by_path(category_path) {
    // const response = await fetch('./my_json_file.json');
    // const json = await response.json();
    
    const data = portfolio_categories_data.categories.find( (c) => c.path == category_path )
    const status = 200
    console.log(JSON.stringify({ status, data }))
    return ({ status, data })
}

export async function get_portfolio_category_items(items) { 
    const data = []
    console.log(JSON.stringify(items))
    items.forEach((item_id) => {
        const item_resp = get_portfolio_item_by_id(item_id)
        data.push(item_resp.data)
    })
    const status = 200
    return { status, data }
}